<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { assignObject, handleAlert, handleConfirm } from "@/utils/UtilsIf";

export default {
  name: "partnerMaintainerShareMoneyDetail",
  components: { breadcrumbs },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      pickerOptionsEnd2: {
        disabledDate: time => {
          let beginDateVal = this.exportForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      form: {
        endTime: "",
        limitEnd: "",
        limitStart: "",
        maintainerId: "",
        orderNumber: "",
        orderType: "",
        partnerName: "",
        regionId: "",
        startTime: "",
        type: 0,
        waterCardNumber: ""
      },
      exportForm: {
        startTime: "",
        endTime: "",
        limitEnd: "",
        limitStart: ""
      }, //导出弹框表单
      exportVisible: false,
      fenquArr: [],
      fenrunStatForm: {
        totalOrderAmount: "",
        totalOrderCount: "",
        totalShareAmount: ""
      },
      interval: 2000,
      radio: "1",
      exportChangeNumVisible: false,
      radioArr: []
    };
  },
  mounted() {
    if (this.$route.query.maintainerId) {
      this.form.maintainerId = this.$route.query.maintainerId;
      this.$refs.customTable.search();
      this.getStatistics();
    }
    this.getFenqu();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
    "exportForm.startTime"() {
      if (this.exportForm.startTime == null) {
        this.exportForm.endTime = null;
      }
    }
  },
  methods: {
    search() {
      this.getStatistics();
      this.$refs.customTable.search();
    },
    reset() {
      Object.assign(this.form, {
        endTime: "",
        orderNumber: "",
        orderType: "",
        partnerName: "",
        regionId: "",
        startTime: "",
        waterCardNumber: ""
      });
      this.getStatistics();
      this.$refs.customTable.search();
    },
    getStatistics() {
      this.$api.partner
        .partnerMaintainerShareStatistics(this.form)
        .then(res => {
          if (res.code === 200) {
            this.fenrunStatForm = assignObject(this.fenrunStatForm, res.data);
          }
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    indexMethod(index) {
      return index + 1;
    },
    // 分区下拉
    getFenqu() {
      this.$api.marketing.allZonePull().then(res => {
        if (res.code === 200) {
          this.fenquArr = res.data;
        }
      });
    },
    exportBtn() {
      this.exportForm = {
        startTime: "",
        endTime: "",
        limitEnd: "",
        limitStart: ""
      };
      this.exportVisible = true;
    },
    exportNumBtn() {
      if (!this.radio) {
        handleAlert("请选择条数范围", "error");
        return;
      }
      this.radioArr.forEach(v => {
        if (this.radio == v.id) {
          this.exportForm.limitStart = v.start;
          this.exportForm.limitEnd = v.end;
        }
      });

      handleConfirm("确认导出吗?", "info")
        .then(() => {
          this.$api.partner
            .partnerMaintainerShareExport({
              ...this.form,
              ...this.exportForm
            })
            .then(res => {
              handleAlert("导出成功", "success");
              // this.exportChangeNumVisible = false;
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(res);
              link.setAttribute(
                "download",
                `消费订单(${this.exportForm.limitStart}-${this.exportForm.limitEnd}).xls`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
        })
        .catch(() => {
          return;
        });
    },
    // 导出
    exportBtnHandle() {
      this.$api.partner
        .getPartnerMaintainerShareExportNum({
          ...this.form,
          startTime: this.exportForm.startTime,
          endTime: this.exportForm.endTime
        })
        .then(res => {
          if (res.code === 200) {
            if (Number(res.data) > this.interval) {
              this.radioArr = []; // 清空之前的范围
              let id = 1; // 从1开始递增的ID
              for (let i = 0; i < res.data; i += this.interval) {
                const end = Math.min(i + this.interval - 1, res.data - 1);
                this.radioArr.push({ id, start: i + 1, end: end + 1 });
                id++;
              }
              this.exportVisible = false;
              this.radio = "";
              this.exportChangeNumVisible = true;
            } else {
              handleConfirm("确认导出吗?", "info").then(() => {
                this.$api.partner
                  .partnerMaintainerShareExport({
                    ...this.form,
                    startTime: this.exportForm.startTime,
                    endTime: this.exportForm.endTime,
                    type: 1,
                    limitStart: 1,
                    limitEnd: res.data
                  })
                  .then(res => {
                    this.exportVisible = false;
                    const link = document.createElement("a");
                    link.style.display = "none";
                    link.href = URL.createObjectURL(res);
                    link.setAttribute("download", "分润信息.xls");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    handleAlert("导出成功", "success");
                  });
              });
            }
          }
        });
    }
  }
};
</script>

<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.back()"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 表单查询 -->
    <div class="pdt-15 pdb-15 bg-white">
      <el-form ref="form" :model="form" label-width="90px" inline>
        <el-form-item label="订单编号">
          <el-input
            v-model="form.orderNumber"
            placeholder="请输入订单编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="分润方式">
          <el-select v-model="form.orderType" placeholder="全部" clearable>
            <el-option label="合伙人充值套餐" value="1"></el-option>
            <el-option label="新用户充值奖励" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合伙人">
          <el-input
            v-model="form.partnerName"
            placeholder="请输入合伙人"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="水卡编号">
          <el-input
            v-model="form.waterCardNumber"
            placeholder="请输入水卡编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="所属分区">
          <el-select clearable v-model="form.regionId" placeholder="全部">
            <el-option
              v-for="(v, i) in fenquArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">查 询 </el-button>
          <el-button @click="reset">重 置 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 统计 -->
    <div class="flex aic jcsb">
      <div class="flex aic fw-600 color0063ea mgt-20 mgb-20">
        <span class="mgr-50"
          >分润订单数：{{ fenrunStatForm.totalOrderCount }}</span
        >
        <span class="mgr-50"
          >分润订单金额（元）：{{ fenrunStatForm.totalOrderAmount }}</span
        >
        <span class="mgr-50"
          >分润金额（元）：{{ fenrunStatForm.totalShareAmount }}</span
        >
      </div>
      <el-button @click="exportBtn">导出</el-button>
    </div>
    <customTable
      ref="customTable"
      :api="$api.partner.partnerMaintainerShareList"
      :params="form"
      :isMounted="false"
      @selection-change="handleSelectionChange"
    >
      <template #columns>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="orderNumber" label="订单编号"></el-table-column>
        <el-table-column prop="orderType" label="分润方式">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.orderType == 1
                  ? '合伙人充值套餐'
                  : scope.row.orderType == 2
                  ? '新用户充值奖励'
                  : '- -'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="partnerName" label="合伙人"></el-table-column>
        <el-table-column
          prop="waterCardNumber"
          label="水卡编号"
        ></el-table-column>
        <el-table-column prop="companyName" label="所属企业"></el-table-column>
        <el-table-column prop="regionName" label="所属分区"></el-table-column>
        <el-table-column prop="actualAmount" label="订单实付金额（元）">
        </el-table-column>
        <el-table-column label="相对分润比例">
          <template #default="{row}"> {{ row.profitRatio }}% </template>
        </el-table-column>
        <el-table-column prop="profitAmount" label="分润金额（元）">
        </el-table-column>
        <el-table-column prop="orderTime" label="交易时间"></el-table-column>
      </template>
    </customTable>
    <!-- 导出弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportVisible"
      width="30%"
      center
      top="30vh"
    >
      <el-form ref="form" :model="exportForm" label-width="100px">
        <el-form-item label="交易开始时间">
          <el-date-picker
            v-model="exportForm.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="交易结束时间">
          <el-date-picker
            v-model="exportForm.endTime"
            :picker-options="pickerOptionsEnd2"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="exportBtnHandle">导 出</el-button>
      </span>
    </el-dialog>
    <!-- 导出选择数据弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportChangeNumVisible"
      width="50%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <el-descriptions column="5" border title="请选择需要导出的数据">
        <el-descriptions-item v-for="(v, i) in radioArr" :key="i" label="范围">
          <el-radio v-model="radio" :label="v.id">{{
            v.start + "-" + v.end + "条"
          }}</el-radio></el-descriptions-item
        >
      </el-descriptions>

      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportChangeNumVisible = false"
          >关 闭</el-button
        >
        <el-button type="primary" @click="exportNumBtn">导 出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss"></style>
